export { datepickerVariables as datepickerCalendarHeaderCellVariables } from './datepickerVariables';
